import "./apply.css";
import ApplicationForm from "./applicationForm.js";
import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios.js";
import LoadingPage from "../../components/loading/loadingPage.js";
import useAuth from "../../hooks/useAuth";
import { canAccessApplications } from "../../utils/princetonAccess";
import { Navigate } from "react-router-dom";
import SchoolEmail from "../../components/SchoolEmail";

const Apply = () => {
  const { authState } = useAuth();
  const [hackathonStatus, setHackathonStatus] = useState("loading");
  const [applicationStatus, setApplicationStatus] = useState("loading");
  const canApply = canAccessApplications(authState.user?.email, hackathonStatus);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const [response, application] = await Promise.all([
          axiosInstance.get("/api/applications/cycle/status"),
          axiosInstance.get("/api/applications/status"),
        ]);
        setApplicationStatus(application.data.status);
        setHackathonStatus(response.data);
      } catch (error) {
        // console.log(error);
      }
    };

    fetchStatus();
  }, []);

  if (applicationStatus !== "loading" && !["unsubmitted", "started"].includes(applicationStatus)) {
    return <Navigate to="/dashboard" replace />;
  }

  const statusTone =
    canApply
      ? "open"
      : hackathonStatus === "loading"
        ? "loading"
        : "closed";

  const statusLabel =
    statusTone === "open"
      ? hackathonStatus === "closed"
        ? "Princeton late applications are still available"
        : "Applications are open"
      : statusTone === "loading"
        ? "Checking status..."
        : "Applications are currently closed";

  return (
    <div className="apply">
      <div className="apply-shell">
        <div className="apply-hero">
          <div className="apply-hero-sky" aria-hidden="true" />
          <div className="apply-title-container">
            <p className="apply-kicker">HackPrinceton Fall 2026</p>
            <h1 className="app-title">Application Portal</h1>
            <p className="apply-subtitle">
              Plan your route, save your progress, and submit your Fall 2026 application.
            </p>
            <div className="apply-meta-row">
              <span className={`apply-status-chip apply-status-${statusTone}`}>
                {statusLabel}
              </span>
              <span className="apply-meta-note">
                Save drafts, review every section, and submit when ready.
              </span>
            </div>
          </div>
        </div>

        <div className="application">
          {hackathonStatus === "loading" ? (
            <LoadingPage />
          ) : canApply ? (
            <SchoolEmail><ApplicationForm /></SchoolEmail>
          ) : (
            <div className="apply-form">
              <div className="apply-closed-card">
                <label className="label">
                  Applications are not currently open.
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Apply;
